const credentialConfirmation = {
  en: {
    translation: {
      success_title: "Success",
      success_text: "You added your email to the credentials monitered successfully",
      error_title: "Error",
      error_text: "Error while adding your email to the credentails monitored",
      checking_title: "Checking",
      checking_text: "We are checking that everything is alright, please wait a moment",
      no_code_title: "No token",
      no_code_text: "Ops! It seems like there is no token to validate",
      success_title_cancel_deletion: "Success",
      success_text_cancel_deletion: "You cancelled the request to delete your user",
      error_title_cancel_deletion: "Error",
      error_text_cancel_deletion: "Error while cancelling the deletion request of your user",
      checking_title_cancel_deletion: "Checking",
      checking_text_cancel_deletion:
        "We are checking that everything is alright, please wait a moment",
      no_code_title_cancel_deletion: "No token",
      no_code_text_cancel_deletion: "Ops! It seems like there is no token to validate",
      go_to_home_cancel_deletion: "Go to homepage",
    },
  },
  it: {
    translation: {
      success_title: "Successo",
      success_text: "Hai aggiunto la tua email alle credenziali monitorate con successo",
      error_title: "Errore",
      error_text: "Errore durante l'aggiunta dell'indirizzo email alle credenziali monitorate",
      checking_title: "Controllo",
      checking_text: "Stiamo controllando che tutto sia a posto, per favore, aspetta un momento",
      no_code_title: "No token",
      no_code_text: "Ops! Sembra che non ci sia un token da validare",
      success_title_cancel_deletion: "Successo",
      success_text_cancel_deletion: "Hai annullato la richiesta di cancellazione del tuo utente",
      error_title_cancel_deletion: "Errore",
      error_text_cancel_deletion:
        "Errore durante l'annullamento della richiesta di cancellazione del tuo utente",
      checking_title_cancel_deletion: "Controllo",
      checking_text_cancel_deletion:
        "Stiamo controllando che tutto sia a posto, per favore, aspetta un momento",
      no_code_title_cancel_deletion: "No token",
      no_code_text_cancel_deletion: "Ops! Sembra che non ci sia un token da validare",
      go_to_home_cancel_deletion: "Torna alla homepage",
    },
  },
};

export default credentialConfirmation;
